import { render, staticRenderFns } from "./formRichText.vue?vue&type=template&id=0b343bf7&scoped=true&"
import script from "./formRichText.vue?vue&type=script&lang=js&"
export * from "./formRichText.vue?vue&type=script&lang=js&"
import style0 from "./formRichText.vue?vue&type=style&index=0&id=0b343bf7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b343bf7",
  null
  
)

export default component.exports